const icons: Record<string, React.FC<{ className?: string }>> = {
  Visa: ({ className }) => (
    <svg className={className} viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#1A1F71" />
      <text x="50%" y="55%" dominantBaseline="middle" textAnchor="middle" fontSize="11" fontFamily="Arial, sans-serif" fontWeight="bold" fill="#fff" letterSpacing="0.5">
        VISA
      </text>
    </svg>
  ),
  Mastercard: ({ className }) => (
    <svg className={className} viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#f7f7f7" />
      <circle cx="18.5" cy="16" r="9" fill="#EB001B" />
      <circle cx="29.5" cy="16" r="9" fill="#F79E1B" />
      <path d="M24 9.5a8.9 8.9 0 000 13" fill="#FF5F00" />
    </svg>
  ),
  Discover: ({ className }) => (
    <svg className={className} viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#fff" />
      <rect x="2" y="2" width="44" height="28" rx="2" fill="#FF6000" />
      <text x="7" y="20" fontSize="9" fontWeight="bold" fill="#fff" fontFamily="Arial, sans-serif">DISCOVER</text>
      <circle cx="40" cy="16" r="5" fill="#fff" />
    </svg>
  ),
  GooglePay: ({ className }) => (
    <svg className={className} viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#fff" />
      <text x="6" y="14" fontSize="8" fontFamily="Arial, sans-serif" fontWeight="bold" fill="#4285F4">G</text>
      <text x="13" y="14" fontSize="8" fontFamily="Arial, sans-serif" fontWeight="bold" fill="#EA4335">o</text>
      <text x="19" y="14" fontSize="8" fontFamily="Arial, sans-serif" fontWeight="bold" fill="#FBBC05">o</text>
      <text x="25" y="14" fontSize="8" fontFamily="Arial, sans-serif" fontWeight="bold" fill="#4285F4">g</text>
      <text x="31" y="14" fontSize="8" fontFamily="Arial, sans-serif" fontWeight="bold" fill="#34A853">l</text>
      <text x="34" y="14" fontSize="8" fontFamily="Arial, sans-serif" fontWeight="bold" fill="#EA4335">e</text>
      <text x="6" y="25" fontSize="8" fontFamily="Arial, sans-serif" fontWeight="bold" fill="#5F6368">Pay</text>
    </svg>
  ),
  ApplePay: ({ className }) => (
    <svg className={className} viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#000" />
      <path
        d="M13 10.5c-.5 0-1.3.3-1.7.3-1 0-1.9-.6-2.9-.6-2.2 0-4 1.6-4 4.4 0 1.7.7 3.5 1.9 4.7 1 1 1.9 1.6 2.9 1.6.6 0 1.3-.4 1.9-.4.8 0 1.5.4 2.4.4 1.7 0 3.5-2.1 3.5-4.3 0-1.1-.5-1.8-1.2-2.6.5-.6.9-1.3.9-2.2 0-1.2-.7-2.2-1.7-2.6.2-.2.5-.3.9-.3 0 0 .3 0 .3-.1-.5.2-1 .3-1.5.3z"
        fill="#fff"
      />
      <text x="20" y="20" fontSize="9" fontFamily="Arial, sans-serif" fontWeight="600" fill="#fff">Pay</text>
    </svg>
  ),
  PayPal: ({ className }) => (
    <svg className={className} viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#fff" />
      <text x="50%" y="58%" dominantBaseline="middle" textAnchor="middle" fontSize="9" fontFamily="Arial, sans-serif" fontWeight="bold" fill="#003087">PayPal</text>
    </svg>
  ),
  Amex: ({ className }) => (
    <svg className={className} viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#016FD0" />
      <text x="50%" y="58%" dominantBaseline="middle" textAnchor="middle" fontSize="9" fontFamily="Arial, sans-serif" fontWeight="bold" fill="#fff">AMEX</text>
    </svg>
  ),
  MTN: () => (
    <img
      src="https://media.getzurihub.com/Jayrah%20Assets/MoMO.jpeg"
      alt="MTN Mobile Money"
      className="h-6 w-10 rounded-md border border-slate-200 bg-white object-contain p-0.5"
    />
  ),
  Airtel: () => (
    <img
      src="https://media.getzurihub.com/Jayrah%20Assets/AirtelMoney.jpeg"
      alt="Airtel Money"
      className="h-6 w-10 rounded-md border border-slate-200 bg-white object-contain p-0.5"
    />
  ),
  BankTransfer: ({ className }) => (
    <svg className={className} viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#F8FAFC" />
      <path d="M24 6l13 7H11L24 6z" fill="#475569" />
      <rect x="14" y="14" width="3" height="9" rx="0.5" fill="#475569" />
      <rect x="20" y="14" width="3" height="9" rx="0.5" fill="#475569" />
      <rect x="26" y="14" width="3" height="9" rx="0.5" fill="#475569" />
      <rect x="32" y="14" width="3" height="9" rx="0.5" fill="#475569" />
      <rect x="11" y="23" width="26" height="3" rx="0.5" fill="#475569" />
      <path d="M38 13l3 2-3 2" stroke="#0EA5E9" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M35 19l-3 2 3 2" stroke="#0EA5E9" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <text x="50%" y="58%" dominantBaseline="middle" textAnchor="middle" fontSize="5" fontFamily="Arial, sans-serif" fontWeight="600" fill="#334155">BANK</text>
    </svg>
  ),
};

const labels: Record<string, string> = {
  Visa: 'Visa',
  Mastercard: 'Mastercard',
  Discover: 'Discover',
  GooglePay: 'Google Pay',
  ApplePay: 'Apple Pay',
  PayPal: 'PayPal',
  Amex: 'American Express',
  MTN: 'MTN Mobile Money',
  Airtel: 'Airtel Money',
  BankTransfer: 'Bank Transfer',
};

export default function PaymentMethods({ className = '', compact = false }: { className?: string; compact?: boolean }) {
  // Show only key payment methods in footer (compact mode)
  const keysToShow = compact 
    ? ['Visa', 'Mastercard', 'PayPal', 'ApplePay', 'GooglePay']
    : Object.keys(icons);

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {keysToShow.map((key) => {
        const Icon = icons[key];
        return (
          <div key={key} className="group relative" title={labels[key]}>
            <Icon className="h-6 w-10 rounded-md shadow-sm" />
          </div>
        );
      })}
    </div>
  );
}
